import React from 'react';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import dropbox from '../imgs/dropbox.svg';
import google from '../imgs/google-drive.svg';
import './styles';
import { FILE_SOURCES } from './constants';
import DeleteButton from '../DeleteButton';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

@injectIntl
@observer
export default class Attachment extends React.Component {
  render() {
    const { attachment, renderHidePreview } = this.props;
    let url = attachment.url;
    let element;

    if (attachment.hasThumbnail()) {
      element = <img src={url} />;
    } else {
      if (attachment.isExternal()) {
        try {
          switch (attachment.source) {
            case FILE_SOURCES.GOOGLE:
              element = <img className={'icon-img'} src={google} />;
              break;
            case FILE_SOURCES.DROPBOX:
              element = <img className={'icon-img'} src={dropbox} />;
              break;
            default:
              element = (
                <div>
                  <i className="file-icon fa fa-link" />
                </div>
              );
              break;
          }
        } catch (err) {
          return null;
        }
      } else {
        element = (
          <div>
            <i className="file-icon fa fa-file-o" />
          </div>
        );
      }
    }

    let fileName =
      attachment.attachmentName.length > 20
        ? attachment.attachmentName.slice(0, 20) + '...'
        : attachment.attachmentName;

    return (
      <div className="attachment-preview img-thumbnail">
        {this.props.canEdit() && (
          <DeleteButton
            pullRight={false}
            onDelete={() => attachment.destroy()}
          />
        )}
        {this.renderHidePreview()}
        <div onClick={() => this.handleFileClick(attachment)}>
          <div className="element-container">{element}</div>
          <div className="name">{fileName}</div>
        </div>
      </div>
    );
  }

  handleFileClick = attachment => {
    window.open(attachment.url, '_blank');
  };

  renderHidePreview = () => {
    const { attachment, canEdit, renderHidePreview, intl } = this.props;

    if (!renderHidePreview || !attachment.hasThumbnail() || !canEdit()) {
      return;
    }

    const toggleHideTooltip = (
      <Tooltip id={`hide-show-preview-${attachment.id}`}>
        {intl.formatMessage({ id: 'hide_show_from_board' })}
      </Tooltip>
    );
    const previewIconClass = attachment.hidePreview
      ? 'fa fa-eye-slash'
      : 'fa fa-eye';

    return (
      <OverlayTrigger placement="bottom" overlay={toggleHideTooltip}>
        <button
          className="btn hide-preview-button btn-semi-transparent"
          onClick={this.toggleHidePreview}
        >
          <i className={previewIconClass} />
        </button>
      </OverlayTrigger>
    );
  };

  toggleHidePreview = e => {
    e.preventDefault();
    e.stopPropagation();
    const { attachment } = this.props;

    attachment.toggleHidePreview();
  };
}

Attachment.propTypes = {
  attachment: PropTypes.object,
  canEdit: PropTypes.func
};

Attachment.defaultProps = {
  renderHidePreview: false
};
